import { render, staticRenderFns } from "./SyllabusShow.vue?vue&type=template&id=432b50ed&scoped=true&"
import script from "./SyllabusShow.vue?vue&type=script&lang=js&"
export * from "./SyllabusShow.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusShow.vue?vue&type=style&index=0&id=432b50ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432b50ed",
  null
  
)

export default component.exports